import { Table } from 'redesign';
import { useMemo } from 'react';
import { OGP } from '@levelworks/shared-backend-api';
import { ExternalFlexPoolsTableColumnDefinition } from './helpers/external-flex-pools-table.types';
import { useExternalFlexPoolsColumnDefinition } from './helpers/use-external-flex-pools-column-definition';
import { getExternalFlexPoolsTableData } from './helpers/get-external-flex-pools-table-data';

type Props = {
  data: OGP.GetWorkersPoolListItemResponseDto[];
  onRowClick?: (row: ExternalFlexPoolsTableColumnDefinition) => void;
};

export const ExternalFlexPoolsTable = ({ data, onRowClick }: Props) => {
  const columns = useExternalFlexPoolsColumnDefinition();
  const tableData = useMemo(() => getExternalFlexPoolsTableData(data), [data]);

  return (
    <Table<ExternalFlexPoolsTableColumnDefinition>
      columns={columns}
      data={tableData}
      onRowClick={onRowClick}
    />
  );
};
